export enum WorkspaceActionType {
  ToggleEditorSidebar = 'ToggleEditorSidebar',
  SelectReportBuilder = 'SelectReportBuilder',
  SelectSqlEditor = 'SelectSqlEditor',
}
